import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeScriptComponent } from './home-script/home-script.component';
import { SalesScriptComponent } from './sales-script/sales-script.component';
import { PricingScriptComponent } from './pricing-script/pricing-script.component';
import { AboutScriptComponent } from './about-script/about-script.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthRoutingModule } from './auth-routing.module';
import { MaterialsModule } from '../materials/materials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordLinkComponent } from './reset-password-link/reset-password-link.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardModule } from '../dashboard/dashboard.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignupBillingComponent } from './signup-billing/signup-billing.component';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { RmImageSliderComponent } from 'rm-image-slider';
import { PasswordStrengthMeterComponent } from '@wise-community/angular-password-strength-meter';
import { provideZxvbnServiceForPSM } from '@wise-community/angular-password-strength-meter/zxcvbn';

@NgModule({
  declarations: [
     HomeScriptComponent,
     SalesScriptComponent,
     PricingScriptComponent,
     AboutScriptComponent, ContactUsComponent,
     SignInComponent,
     SignUpComponent,
     ForgetPasswordComponent,
     ResetPasswordComponent,
     ResetPasswordLinkComponent,
     VerifyAccountComponent,
     PrivacyComponent,
     TermsComponent,
     SignupBillingComponent,
     VideoDialogComponent,
     VerifyEmailComponent],
    imports: [
        BrowserAnimationsModule,
        MaterialsModule,
        AuthRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        DashboardModule,
        NgxCaptchaModule,
        RmImageSliderComponent,
        PasswordStrengthMeterComponent
      ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    provideZxvbnServiceForPSM()
  ]
})
export class AuthModule { }
